import { datadogLogs } from "@datadog/browser-logs";
import { withGlobalSpinner } from "lib/api";
import { useEffect, useState } from "react";
import { getDiscoveryJourneySlides } from "./api";
import type { DiscoveryJourneySlides } from "./types";

type DiscoveryJourneyModule = {
  loading: boolean;
  slides: DiscoveryJourneySlides[];
};

export const useDiscoveryJourney = (): DiscoveryJourneyModule => {
  const [loading, setLoading] = useState(true);
  const [journeySlides, setJourneySlides] = useState<DiscoveryJourneySlides[]>(
    []
  );

  useEffect(() => {
    (async () => {
      try {
        const slides = await withGlobalSpinner(getDiscoveryJourneySlides)();
        setJourneySlides(slides);
      } catch (error) {
        datadogLogs.logger.error(
          "Failed fetching discovery journey slides",
          error as Error
        );
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return {
    loading,
    slides: journeySlides
  };
};
